<div [chart]="highchart" [ngStyle]="{ height: chartheight }"></div>
